import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import styles from './LoginCard.module.css';
import { apiPostAuth } from '../../utils/api';

const LoginCard = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const data = await apiPostAuth('/api/auth/login', {
        identifier,
        password,
      });

      // Backend liefert: { token, user }
      login(data.user, data.token);

      navigate('/dashboard');
    } catch (err) {
      setError(err.error || 'Login fehlgeschlagen');
    }
  };

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>login</h3>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="name or tagname"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          className={styles.input}
        />

        <div className={styles.passwordWrapper}>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="pwd"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={styles.input}
          />

          <button
            type="button"
            className={styles.eyeBtn}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
          </button>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <button type="submit" className={styles.button}>
          submit
        </button>
      </form>
    </div>
  );
};

export default LoginCard;